import { render } from "./GenericTabs.vue?vue&type=template&id=1820d2ad&scoped=true"
import script from "./GenericTabs.vue?vue&type=script&lang=js"
export * from "./GenericTabs.vue?vue&type=script&lang=js"

import "./GenericTabs.vue?vue&type=style&index=0&id=1820d2ad&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1820d2ad"]])

export default __exports__